import { LocalStorageToken } from '../interactors/services/AuthService'

export const LEGACY_INTERFACE_ORIGIN = 'https://ancien.petso.fr'

/**
 * Link to the previous interface, for a member who hits a problem here and needs to finish a task
 * in the interface they know.
 *
 * Both interfaces keep the session in localStorage, which is scoped per origin, so following a bare
 * link would land the member logged out. The token is handed over in the URL fragment instead: a
 * fragment never reaches a server, so it stays out of access logs and out of anything in between,
 * and the receiving page clears it from the address bar immediately.
 *
 * Without a session, the plain login page of the previous interface is returned.
 */
export const getLegacyInterfaceUrl = (): string => {
  let token: string | null = null

  try {
    token = LocalStorageToken.getCurrentToken()
  } catch {
    // Storage can be unavailable (private browsing, blocked site data): fall back to a plain login.
    token = null
  }

  if (!token) {
    return `${LEGACY_INTERFACE_ORIGIN}/login`
  }

  return `${LEGACY_INTERFACE_ORIGIN}/handoff#token=${encodeURIComponent(token)}`
}

export const LEGACY_INTERFACE_LABEL = 'Ancienne interface'
